var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"users-page"},[_c('AddNew'),_c('List'),_c('ChangePassModal'),_c('DeleteModal'),_c('AddModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }